import { AxiosError } from "axios";
import useSWR from "swr";
import { useEffect, useState } from "react";
import {
  GetStatistics200Response,
  InstrumentTypeResponse,
} from "../../../codegen-api";
import { APIEndpointEnum } from "../../../enums/endpoint";
import { publicApi } from "../../../services/api/apiFetcher";
import { useLoggerMiddleware } from "../middleware/useLoggerMiddleware";
import {
  pollingDelay,
  pollingInterval,
} from "../../../services/api/pollingInterval";
import { AssetResponse } from "../../../utils/asset";

export const useGetStatistics = (
  asset?: AssetResponse,
  instrumentType?: InstrumentTypeResponse,
  /** Override the shared poll, for a consumer that needs fresher prices. */
  refreshInterval: number | undefined = pollingInterval[APIEndpointEnum.STATISTICS]
) => {
  const fetcher = publicApi();
  const delay = pollingDelay[APIEndpointEnum.STATISTICS];
  const [startsQuery, setStartsQuery] = useState(!delay);

  useEffect(() => {
    if (!delay) return;
    // Wait before querying
    const t = setTimeout(() => {
      setStartsQuery(true);
    }, delay);
    return () => clearTimeout(t);
  }, [delay]);

  return useSWR<GetStatistics200Response, AxiosError>(
    asset && instrumentType && startsQuery
      ? [APIEndpointEnum.STATISTICS, asset, instrumentType]
      : undefined,
    async () =>
      (await (await fetcher.getStatistics(asset!, instrumentType!))()).data,
    {
      use: [useLoggerMiddleware],
      refreshInterval,
      // Collapse duplicate/staggered-mount fetches across consumers (per-asset
      // keys remain distinct). Kept below the 60s poll so freshness is unchanged.
      dedupingInterval: 10000,
    }
  );
};
